import { OutstreamCaptionsPayload } from '@sharethrough/groundcontrol-enhancement-flush';
import Beacons from 'modules/beacons/utils';
import { HostedVideoCreative, VastVideoCreative } from 'modules/butler/creative';
import { CaptionsContext } from 'modules/enhancements/captions/captionsProvider';
import { FunctionComponent, h } from 'preact';
import { useContext, useEffect, useState } from 'preact/hooks';
import { useButler, useEnhancement } from 'tag/models/ad-experiences/hooks';
import DefaultEnhancement from '../default-content.component';
import Advertiser from "../../advertiser";

interface CaptionsEnhancementState {
  currentSubtitle: Array<string>;
  previousSubtitle: Array<string>;
  showPrevCaption: boolean;
  showNextCaption: boolean;
}

const hasInnerCreativeId = (
  enhancement: OutstreamCaptionsPayload | null,
  creative: VastVideoCreative | HostedVideoCreative,
  innerCreativeId: string
) => {
  if (!enhancement) {
    return Object.keys(creative.srt).includes(innerCreativeId);
  }

  return Object.keys(enhancement.payload.srt).includes(innerCreativeId);
};

const CaptionsEnhancement: FunctionComponent = () => {
  const butlerResponse = useButler();
  const { enhancement } = useEnhancement<OutstreamCaptionsPayload>();
  const captions = useContext(CaptionsContext);
  const currentSubtitle = captions?.currentSubtitle?.text ?? '';

  const [state, setState] = useState<CaptionsEnhancementState>({
    currentSubtitle: currentSubtitle?.split('<br />') || [],
    previousSubtitle: [],
    showPrevCaption: true,
    showNextCaption: false
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setState((prevState) => ({ ...prevState, showPrevCaption: false, showNextCaption: true }));
    }, 50);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setState((prevState) => ({
      previousSubtitle: prevState.currentSubtitle,
      currentSubtitle: currentSubtitle?.split('<br />') || [],
      showPrevCaption: true,
      showNextCaption: false
    }));

    const timer = setTimeout(() => {
      setState((prevState) => ({ ...prevState, showPrevCaption: false, showNextCaption: true }));
    }, 50);

    return () => clearTimeout(timer);
  }, [currentSubtitle]);

  if (!butlerResponse || !captions) {
    return null;
  }

  // not the preferred approach but this fallbacks to the default enhancement when there are no captions for the current innerCreativeId
  if (!hasInnerCreativeId(enhancement, butlerResponse.creative as any, captions.innerCreativeId)) {
    return <DefaultEnhancement />;
  }

  const { previousSubtitle, currentSubtitle: newSubtitle, showPrevCaption, showNextCaption } = state;

  Beacons.fire.videoSubtitlesEnabled(butlerResponse.adserverRequestId, true);

  return (
    <div className="str-enhanced-info">
      <div className={`str-text ${currentSubtitle !== undefined ? 'str-captions' : ''}`}>
        <div style={{ display: 'flex', textAlign: 'center' }}>
          <div
            style={{ flex: 1 }}
            className={`str-title str-caption-container str-prev-caption ${
              showPrevCaption ? '' : 'str-caption-scroll-up'
            }`}
          >
            {previousSubtitle?.map((subtitle, index) => (
              <span key={index}>{subtitle}</span>
            ))}
          </div>
          <div
            style={{ flex: 1 }}
            className={`str-title str-caption-container str-current-caption ${
              showNextCaption ? 'str-caption-show' : 'str-caption-bottom'
            }`}
          >
            {newSubtitle?.map((subtitle, index) => (
              <span key={index}>{subtitle}</span>
            ))}
          </div>
        </div>
      </div>
      <div className="str-bottom">
        <Advertiser />
      </div>
    </div>
  );
};

export default CaptionsEnhancement;
